var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-wrapper"},[_c('div',{staticClass:"brand-image"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"brand-name"},[_vm._v(_vm._s(_vm.brand.name))]),_c('div',{staticClass:"brand-info-text",on:{"click":_vm.gotoBrandDetail}},[_vm._v("브랜드 관 보기")])])
}
var staticRenderFns = []

export { render, staticRenderFns }